@if (data) {
  @if ((fundAllocationStep$ | async) === fundAllocationSteps.CONFIRM_ACTION) {
    <mat-dialog-content>
      @if (data.action === actions.ADD) {
        <h2 class="matDialogTitle">{{ fundAllocationsTitles.ADD_FUNDS }}</h2>
      }
      @if (data.action === actions.REALLOCATE) {
        <h2 class="matDialogTitle">
          {{ fundAllocationsTitles.REALLOCATE_FUNDS }}
        </h2>
      }
      @if (data.action === actions.MOVE_FUNDS) {
        <h2 class="matDialogTitle">{{ fundAllocationsTitles.MOVE_FUNDS }}</h2>
      }
      @if (data.action === actions.ALLOCATE) {
        <h2 class="matDialogTitle">{{ fundAllocationsTitles.ALLOCATE }}</h2>
      }
      <p class="matDialogSubtitle">
        {{ fundAllocationsTitles.PERMISSIONS }}
      </p>
      <mat-dialog-actions class="matDialogActions">
        <button
          mat-flat-button
          class="matDialogActionButton fundAllocationsPrimaryColorItems"
          matDialogClose
        >
          {{ fundAllocationButtons.CANCEL }}
        </button>
        <button
          mat-flat-button
          [ngClass]="{
            enabledButton: true
          }"
          (click)="onConfirm()"
        >
          {{ fundAllocationButtons.CONFIRM }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
  @if (data.action === actions.ADD) {
    <app-add-funds
      [data]="data"
      [fundAllocationForm]="fundAllocationForm"
      [fundAllocationStep]="(fundAllocationStep$ | async) ?? 0"
      [universitiesWithCapped]="(universitiesWithCapped$ | async) ?? []"
      [allocationMoney]="allocationMoney"
      [splitOrAdd]="(splitOrAdd$ | async) ?? false"
      [universityMaxAllocationCap]="universityMaxAllocationCap"
      [universitiesToSplitMoney]="universitiesToSplitMoney"
      (next)="onNext()"
      (cancel)="onCancel()"
      (back)="onBack()"
      (confirm)="onConfirm()"
      (allocationMoneyChange)="allocationMoney = $event"
      (addToTotal)="addToTotalFund($event)"
    ></app-add-funds>
  }
  @if (data.action === actions.REALLOCATE) {
    <app-reallocate-funds
      [data]="data"
      [reallocateFundsForm]="reallocateFundsForm"
      [checkDecimals]="checkDecimals"
      [fundAllocationStep]="(fundAllocationStep$ | async) ?? 0"
      [universityMaxAllocationCap]="universityMaxAllocationCap"
      [reallocationUniversities]="(reallocationUniversities$ | async) ?? []"
      [filterUniversityAmounts]="filterUniversityAmounts.bind(this)"
      (setInput)="setInput($event.event, $event.type)"
      (next)="onNext()"
      (cancel)="onCancel()"
      (back)="onBack()"
      (confirm)="onConfirm()"
      (onInput)="onInput()"
    ></app-reallocate-funds>
  }
  @if (data.action === actions.MOVE_FUNDS) {
    <app-move-funds
      [data]="data"
      [moveFundsForm]="moveFundsForm"
      [checkDecimals]="checkDecimals"
      [fundAllocationStep]="(fundAllocationStep$ | async) ?? 0"
      [universityMaxAllocationCap]="universityMaxAllocationCap"
      [moveFundsDepartments]="(moveFundsDepartments$ | async) ?? []"
      [filterDepartmentAmounts]="filterDepartmentAmounts.bind(this)"
      (setInput)="setInput($event.event, $event.type)"
      (next)="onNext()"
      (cancel)="onCancel()"
      (back)="onBack()"
      (confirm)="onConfirm()"
      (onInput)="onInput()"
    ></app-move-funds>
  }
  @if (data.action === actions.ALLOCATE) {
    <app-allocate-funds-dialog
      [data]="data"
      [allocateFundsForm]="allocateFundsForm"
      [checkDecimals]="checkDecimals"
      [fundAllocationStep]="(fundAllocationStep$ | async) ?? 0"
      [unallocatedLess]="unallocatedLess"
      [universitiesWithCapped]="(universitiesWithCapped$ | async) ?? []"
      [filterUniversityAmounts]="filterUniversityAmounts.bind(this)"
      (next)="onNext()"
      (cancel)="onCancel()"
      (back)="onBack()"
      (confirm)="onConfirm()"
      (onInput)="onInput()"
    ></app-allocate-funds-dialog>
  }
  @if (
    (fundAllocationStep$ | async) === fundAllocationSteps.SUCCESS &&
    (data.action === actions.ADD ||
      data.action === actions.REALLOCATE ||
      data.action === actions.MOVE_FUNDS ||
      data.action === actions.ALLOCATE) &&
    successfulAllocationsUpdate
  ) {
    <mat-dialog-content>
      @if (data.action === actions.ADD && !(splitOrAdd$ | async)) {
        <h2 class="matDialogTitle">{{ fundAllocationsTitles.ADD_SUCCESS }}</h2>
      }
      @if (data.action === actions.REALLOCATE) {
        <h2 class="matDialogTitle">
          {{ fundAllocationsTitles.REALLOCATE_SUCCESS }}
        </h2>
      }
      @if (data.action === actions.MOVE_FUNDS) {
        <h2 class="matDialogTitle">{{ fundAllocationsTitles.MOVE_SUCCESS }}</h2>
      }
      @if (data.action === actions.ALLOCATE) {
        <h2 class="matDialogTitle">
          {{ fundAllocationsTitles.ALLOCATE_SUCCESS }}
        </h2>
      }
      @if (data.action === actions.ADD && (splitOrAdd$ | async)) {
        <h2 class="matDialogTitle">
          {{ fundAllocationsTitles.ADD_TO_FUND_SUCCESS }}
        </h2>
      }
      @if (data.action === actions.ADD && !(splitOrAdd$ | async)) {
        <p class="matDialogSubtitle">
          {{ fundAllocationsTitles.ADD_SUCCESS_SUB }}
        </p>
      }
      @if (data.action === actions.REALLOCATE) {
        <p class="matDialogSubtitle">
          {{ fundAllocationsTitles.REALLOCATE_SUCCESS_SUB }}
        </p>
      }
      @if (data.action === actions.MOVE_FUNDS) {
        <p class="matDialogSubtitle">
          {{ fundAllocationsTitles.MOVE_SUCCESS_SUB }}
        </p>
      }
      @if (data.action === actions.ALLOCATE) {
        <p class="matDialogSubtitle">
          {{ fundAllocationsTitles.ALLOCATE_SUCCESS_SUB }}
          {{ allocateFundsForm.get("university")?.value }}
        </p>
      }
      @if (data.action === actions.ADD && (splitOrAdd$ | async)) {
        <p class="matDialogSubtitle">
          {{ fundAllocationsTitles.ADD_TO_FUND_SUCCESS_SUB }}
        </p>
      }
      <mat-dialog-actions
        [ngClass]="{
          matDialogActionsSuccess:
            (fundAllocationStep$ | async) === fundAllocationSteps.SUCCESS,
          matDialogActions:
            (fundAllocationStep$ | async) !== fundAllocationSteps.SUCCESS
        }"
      >
        <button
          mat-flat-button
          [ngClass]="{
            enabledButton: successfulAllocationsUpdate
          }"
          [disabled]="successfulAllocationsUpdate ? false : true"
          (click)="backToAllocationFunds()"
          class="backToAllocationFunds"
        >
          {{ fundAllocationButtons.BACK_TO_FUND_ALLOCATION }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
}
